import { render, staticRenderFns } from "./GroupsDialog.vue?vue&type=template&id=104613fb"
import script from "./GroupsDialog.vue?vue&type=script&lang=ts"
export * from "./GroupsDialog.vue?vue&type=script&lang=ts"
import style0 from "./GroupsDialog.vue?vue&type=style&index=0&id=104613fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports